export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";